export type DateRange = { start?: Date; end?: Date };

export function isDateRange(value: unknown): value is DateRange {
  return value != null && typeof value === 'object' && 'start' in value && 'end' in value;
}

export class DateHelper {
  static endOfYear(): Date {
    const now = new Date();
    return new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999); // December 31, 23:59:59.999
  }

  static beginningOfYear(): Date {
    const now = new Date();
    return new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0); // January 1, 00:00:00.000
  }

  static daysAgo(days: number): DateRange {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - days);
    return { start, end };
  }

  static monthsAgo(months: number): DateRange {
    const end = new Date();
    const start = new Date();
    start.setMonth(end.getMonth() - months);
    return { start, end };
  }

  static yearsAgo(years: number): DateRange {
    const end = new Date();
    const start = new Date();
    start.setFullYear(end.getFullYear() - years);
    return { start, end };
  }
}

export class TimeSpan {
  static fromMinutes(minutes: number): number {
    return minutes * 60 * 1000;
  }

  static fromHours(hours: number): number {
    return hours * 60 * 60 * 1000;
  }

  static fromSeconds(seconds: number): number {
    return seconds * 1000;
  }
}

export const DefaultDateRanges = [
  {
    value: <DateRange>{ start: DateHelper.daysAgo(1).start, end: new Date() },
    label: '24 Hours',
    icon: 'today',
  },
  {
    value: <DateRange>{ start: DateHelper.daysAgo(3).start, end: new Date() },
    label: '3 Days',
    icon: 'date_range',
  },
  {
    value: <DateRange>{ start: DateHelper.daysAgo(7).start, end: new Date() },
    label: '7 Days',
    icon: 'calendar_view_week',
  },
  {
    value: <DateRange>{ start: DateHelper.monthsAgo(1).start, end: new Date() },
    label: '1 Month',
    icon: 'calendar_month',
  },
  {
    value: <DateRange>{ start: DateHelper.monthsAgo(3).start, end: new Date() },
    label: '3 Months',
    icon: 'calendar_view_month',
  },
  {
    value: <DateRange>{ start: DateHelper.yearsAgo(1).start, end: new Date() },
    label: '12 Months',
    icon: 'view_agenda',
  },
];
